// Dependencies
import styled from 'styled-components';

const FooterStyles = styled.footer`
  width: 100%;
  margin-top: 2rem;

  .top {
    width: 100%;
    padding: 4.125rem 0 3.5rem;
    background-color: var(--color-bark);

    .newsletter,
    .explore,
    .offices,
    .contact {
      width: 100%;
      text-align: center;

      .heading {
        margin: 0 0 1rem;
        font-size: 1.125rem;
        line-height: 1;
      }

      .menu ul {
        margin: 0;
        padding: 0;
        list-style: none;
      }
    }

    .explore,
    .offices,
    .contact {
      margin-bottom: 2.5rem;

      .heading {
        color: #fff;
      }
    }

    .explore,
    .offices {
      .menu {
        margin-left: -0.2rem;

        ul {
          display: flex;
          flex-wrap: wrap;
          max-width: 30rem;
          margin: 0 auto;

          li {
            margin: 0 auto 1rem;
            width: 50%;

            a {
              padding: 0.2rem;
              font-size: 1rem;
              line-height: 1.2;
              color: #fff;
            }
          }
        }
      }
    }

    .newsletter {
      margin: 4rem 0 0;
    }

    .contact {
      .tel,
      .email {
        display: block;
        margin: 0 0 1rem;
        padding: 0.2rem;
        color: #fff;
      }

      .social {
        display: flex;
        justify-content: center;
        margin: 0 0 2.25rem -1rem;
        list-style: none;

        li {
          margin: 0 0.5rem;

          a {
            padding: 0.5rem;

            .icon {
              width: 1.625rem;
              transition: fill 0.4s;
            }

            &:hover,
            &:focus {
              .icon {
                fill: #fff;
              }
            }
          }
        }
      }

      .menu ul {
        display: flex;
        justify-content: center;
        flex-wrap: wrap;

        li {
          margin: 0 1rem 1rem 0;
        }
      }
    }
  }

  .bottom {
    width: 100%;
    padding: 1.5rem 0;
    background-color: var(--color-charcoal);

    .copyright {
      width: 100%;
      margin: 0 0 1rem;
      padding: 0;
      font-size: 0.813rem;
      font-weight: var(--font-weight-regular);
      color: #fff;
    }

    .legal-wrapper {
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      width: 100%;

      .legal {
        margin-left: -0.313rem;

        ul {
          display: flex;
          margin: 0;
          padding: 0;
          list-style: none;

          li {
            a {
              padding: 0.313rem;
              font-size: 0.813rem;
              font-weight: var(--font-weight-medium);
              color: #fff;
            }

            .pipe {
              padding: 0 0.1rem;
              font-size: 0.913rem;
              font-weight: var(--font-weight-medium);
              color: #fff;
            }

            &:last-child .pipe {
              display: none;
            }
          }
        }
      }

      .calling-card {
        font-size: 0.813rem;
        font-weight: var(--font-weight-light);
        color: #fff;

        a {
          font-weight: var(--font-weight-medium);
          color: #fff;

          &:hover,
          &:focus {
            color: #fff;
          }
        }
      }
    }
  }

  @media (min-width: 768px) {
    margin-top: 2.5rem;

    .top {
      & > .container {
        display: grid;
        grid-auto-rows: 1fr;
        grid-template-columns: repeat(2, 1fr);
        gap: 2.5rem;
      }

      .newsletter,
      .explore,
      .offices,
      .contact {
        width: 100%;
        margin: 0 0 3.5rem;
      }

      .explore,
      .offices,
      .contact {
        padding: 1rem 0 0;
        text-align: left;
      }

      .explore,
      .offices {
        .menu {
          ul {
            margin: 0;
            li {
              margin: 0 0 0.5rem;

              a {
                font-size: 1.125rem;

                &:hover,
                &:focus {
                  color: var(--color-charcoal);
                }
              }
            }
          }
        }
      }

      .contact {
        order: 4;

        .tel,
        .email {
          margin-left: -0.2rem;

          &:hover,
          &:focus {
            color: var(--color-charcoal);
          }
        }

        .social,
        .menu ul {
          justify-content: flex-start;
        }
      }

      .explore {
        order: 2;
      }

      .offices {
        order: 3;
      }

      .newsletter {
        order: 1;
      }
    }

    .bottom {
      .copyright {
        margin: 0 0 1.2rem;
        font-size: 1.125rem;
      }

      .legal-wrapper {
        .legal ul li {
          a {
            font-size: 1.125rem;
          }

          .pipe {
            font-size: 1.1rem;
          }
        }

        .calling-card {
          font-size: 1.125rem;
        }
      }
    }
  }

  @media (min-width: 1200px) {
    .top {
      padding: 4.75rem 0 5.25rem;

      & > .container {
        grid-template-columns: repeat(4, 1fr);
      }

      .newsletter,
      .explore,
      .offices,
      .contact {
        margin: 0;
        text-align: left;
      }

      .explore,
      .offices {
        .menu ul li {
          width: 100%;
        }
      }
    }

    .bottom {
      padding: 2rem 0;
    }
  }

  @media (min-width: 1600px) {
    .top {
      .explore,
      .offices {
        .menu ul li {
          width: 50%;
        }
      }
    }
  }
`;

export default FooterStyles;
